import React from 'react'

export default function Reset() {
  const resetCache = () => {
    localStorage.clear()
    window.location.reload(true)
  }
  return (
    <>
      <p>v1.0.0</p>
      <button onClick={resetCache} id="clear-button">Clear Cookies and Cache</button>
      <p><a href="/">Home.</a></p>
    </>
  )
}
